<template>
	<div>
		<!--<nav class="navbar navbar-expand navbar-dark bg-dark fixed-top">
			<router-link
				class="navbar-brand"
				to="/"
			>HH</router-link>
			<button
				class="navbar-toggler"
				type="button"
				data-toggle="collapse"
				data-target="#navbarSupportedContent"
				aria-controls="navbarSupportedContent"
				aria-expanded="false"
				aria-label="Toggle navigation"
			>
				<span class="navbar-toggler-icon"></span>
			</button>

			<div
				class="collapse navbar-collapse"
				id="navbarSupportedContent"
			>
					<ul class="navbar-nav ml-auto">
					<li class="nav-item">
						<a
							class="nav-link"
							href="#"
						><i class="fas fa-cog"></i></a>
					</li>
				</ul>
			</div>
		</nav>-->
		<div class="d-flex h-100vh __pt-6">
			<GameTable />
		</div>
	</div>
</template>

<script>
import GameTable from "@/components/GameTable.vue";

export default {
	name: "game",
	components: {
		GameTable
	}
};
</script>

<style lang="scss">
.h-100vh {
	height: 100vh;
}
.pt-6 {
	padding-top: 3.5rem;
}
</style>

